<template>
  <div id="tr-check-box">
    <input type="checkbox" :id="'input' + mainIndex + '_' + index" v-model="dataModel" />
    <span
      class="checkmark"
      :class="[
        { block: checkboxDataModel.block },
        { correct: checkboxDataModel.status === 'correct' },
        { incorrect: checkboxDataModel.status === 'incorrect' },
      ]"
    ></span>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  name: 'tr-check-box',
  props: {
    checkboxDataModel: {
      type: Object,
      default: function () {
        return { correct: false, value: false, block: false, status: 'rest' };
      },
    },
    mainIndex: {
      type: null,
      default: 0,
    },
    index: {
      type: null,
      default: 0,
    },
  },
  mounted() {
    // console.log( 'checkboxDataModel', this.checkboxDataModel );
  },
  computed: {
    dataModel: {
      get() {
        return this.checkboxDataModel.value;
      },
      set(newValue) {
        this.checkboxDataModel.value = newValue;
        this.checkboxDataModel.value
          ? (this.checkboxDataModel.status = 'set')
          : (this.checkboxDataModel.status = 'rest');
      },
    },
  },
};
</script>
<style lang="scss" scoped>
/* Hide the browser's default radio button */
#tr-check-box input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 49px;
  width: 49px;
  background-image: url('~@/assets/icons/both/game/testIcons/default.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 50%;
  // background-color: #fbfbfb;
}

/* On mouse-over, add a grey background color */
// #tr-check-box:hover input ~ .checkmark {
//     // background-color: #ccc;
//     background-image: url("~@/assets/icons/both/game/testIcons/set.png");
// }

/* When the radio button is checked, add a blue background */
#tr-check-box input:checked ~ .checkmark {
  background-image: url('~@/assets/icons/both/game/testIcons/set.png');
}
// correct style
#tr-check-box input:checked ~ .checkmark.correct {
  background-image: url('~@/assets/icons/both/game/testIcons/correct.png');
}
// incorrect style
#tr-check-box input:checked ~ .checkmark.incorrect {
  background-image: url('~@/assets/icons/both/game/testIcons/incorrect.png');
}
// #tr-check-box input:checked ~ .checkmark.block {
//     pointer-events: none;
// }

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
#tr-check-box input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
#tr-check-box .checkmark:after {
  // top: 9px;
  // left: 9px;
  // width: 8px;
  // height: 8px;
  // border-radius: 50%;
  // background: white;
  visibility: hidden;
}
</style>
